export default __webpack_public_path__ + "static/22-7e64f4e8bd78dc20c0ae44a126082f7c.jpg";